import clsx from "clsx";
import { APPLICATION_STAGES, FINANCING_SCHEDULE_STATUS, LOAN_STATUSES, PAYMENT_STATUS_STATES, STATUS_OPTIONS, SUSU_CYCLE_STATUS } from "../../resources/enums";
import { sentenceCase } from "../../utilities/miscFunctions";

export default function StatusBadge({ status }: { status: STATUS_OPTIONS | LOAN_STATUSES | FINANCING_SCHEDULE_STATUS | APPLICATION_STAGES | SUSU_CYCLE_STATUS | PAYMENT_STATUS_STATES }) {
    return (
        <span
            className={clsx(`px-2 py-1 text-xs rounded-full`,
                { ["!bg-green-100 !text-green-700"]: status === LOAN_STATUSES.ACTIVE || status === STATUS_OPTIONS.ACTIVE || status === FINANCING_SCHEDULE_STATUS.PAID || status === LOAN_STATUSES.SETTLED || status === PAYMENT_STATUS_STATES.SUCCESS },
                { ["!bg-green-700 !text-white"]: status === STATUS_OPTIONS.APPROVED || status === SUSU_CYCLE_STATUS.COMPLETED },
                { ["!bg-red-100 !text-red-600"]: status === STATUS_OPTIONS.INACTIVE || status === STATUS_OPTIONS.CANCELLED || status === LOAN_STATUSES.IN_ACTIVE },
                { ["!bg-yellow-100 !text-yellow-700"]: status === STATUS_OPTIONS.PENDING || status === SUSU_CYCLE_STATUS.WITHDRAWN },
                { ["!bg-purple-100 !text-purple-700"]: status === FINANCING_SCHEDULE_STATUS.PARTIALLY_PAID || status === APPLICATION_STAGES.DISBURSED || status === SUSU_CYCLE_STATUS.PARTIALLY_WITHDRAWN },
            )}
        >
            {sentenceCase(status)}
        </span>
    );
}